var DEFAULT_REFRESH_AFTER_MS = 40 * 60 * 1000;
var DEFAULT_IDLE_MS = 5 * 60 * 1000;
var ACTIVITY_EVENTS = [
  'keydown',
  'mousedown',
  'mousemove',
  'pointerdown',
  'scroll',
  'touchstart',
  'input'
];

function start(options) {
  options = options || {};

  var browserWindow = options.window || window;
  var browserDocument = options.document || document;
  var now = options.now || Date.now;
  var schedule = options.setTimeout || setTimeout;
  var cancel = options.clearTimeout || clearTimeout;
  var refreshAfterMs = options.refreshAfterMs || DEFAULT_REFRESH_AFTER_MS;
  var idleMs = options.idleMs || DEFAULT_IDLE_MS;
  var reload = options.reload || function () {
    browserWindow.location.reload();
  };
  var startedAt = now();
  var lastActivityAt = startedAt;
  var timer = null;
  var stopped = false;

  function recordActivity() {
    lastActivityAt = now();
  }

  function removeListeners() {
    ACTIVITY_EVENTS.forEach(function (eventName) {
      browserDocument.removeEventListener(eventName, recordActivity);
    });
    browserWindow.removeEventListener('focus', recordActivity);
  }

  function stop() {
    if (stopped) return;
    stopped = true;
    if (timer !== null) cancel(timer);
    timer = null;
    removeListeners();
  }

  function check() {
    timer = null;
    if (stopped) return;

    var currentTime = now();
    var untilOldEnough = Math.max(0, refreshAfterMs - (currentTime - startedAt));
    var untilIdle = Math.max(0, idleMs - (currentTime - lastActivityAt));

    if (untilOldEnough === 0 && untilIdle === 0) {
      stop();
      reload();
      return;
    }

    timer = schedule(check, Math.max(untilOldEnough, untilIdle));
  }

  ACTIVITY_EVENTS.forEach(function (eventName) {
    browserDocument.addEventListener(eventName, recordActivity);
  });
  browserWindow.addEventListener('focus', recordActivity);

  timer = schedule(check, Math.max(refreshAfterMs, idleMs));
  return stop;
}

module.exports = {
  start: start,
  DEFAULT_REFRESH_AFTER_MS: DEFAULT_REFRESH_AFTER_MS,
  DEFAULT_IDLE_MS: DEFAULT_IDLE_MS,
  ACTIVITY_EVENTS: ACTIVITY_EVENTS
};
